import React from 'react';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var InfoTags = function InfoTags(_ref) {
  var values = _ref.values;
  if (!(values !== null && values !== void 0 && values.length)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn('parameters'),
    "data-t-id": "components-InfoTags"
  }, values && values.map(function (_ref2) {
    var unit = _ref2.unit,
      value = _ref2.value;
    return /*#__PURE__*/React.createElement("div", {
      className: cn('parameter'),
      key: value
    }, /*#__PURE__*/React.createElement(Text, {
      className: "mar-r-m",
      size: "size5-m"
    }, value), /*#__PURE__*/React.createElement(Text, {
      color: "grey60",
      size: "size5-r-l"
    }, unit));
  }));
};